"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "m17.954 4.91.004.005.11.117c-.005 4.249-.005 8.498-.005 12.745v3.177c-4.248.001-10.333.002-12.795 0V5.527l.001-3.18h.592c2.844 0 7.558.003 9.732-.009.78.878 1.582 1.738 2.361 2.574ZM4.234 23.28c-.843-.003-1.293-.41-1.293-1.174V5.526l.001-4.153C2.942.49 3.43.018 4.187.018h1.681c2.849.002 7.557.004 9.72-.008.706-.004 1.242.214 1.686.715.78.88 1.584 1.742 2.387 2.604l.273.293c.314.336.46.707.46 1.149-.004 4.272-.004 8.544-.004 12.816v4.524c0 .755-.457 1.17-1.3 1.17-5.05.002-13.97.003-14.856 0ZM14.576 9.029v3.491h1.734V9.91s.043-.873-.866-.873c-.353 0-.868-.008-.868-.008ZM6.728 12.52l-.006-2.48s-.011-1.01.981-1.01c.993 0 .734.004.734.004v3.486H6.728Zm1.74 4.364H6.73s-.01 2.227-.01 2.627c0 .4.303.864.874.864h.872v-3.491Zm5.236 0v3.49h-1.746v-3.49h1.746Zm-2.618 0H9.34v3.49h1.746v-3.49Zm.872-7.855h1.746v3.491h-1.746V9.03Zm-2.618 0v3.491h1.746V9.03H9.34Zm5.208 11.341v-4.36H6.722v-2.62h9.595l.002 2.013.003 4.101c0 .233-.192.869-.88.869-.686 0-.894-.005-.894-.005Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};